<template>
  <div class="account-setting">
    <header>
      <el-button type="danger" @click="registration">分配账号</el-button>
    </header>
    <section>
      <el-table
        :data="userDataList"
        border
        stripe
        height="83vh"
        :header-cell-style="{
          color: '#000',
          fontSize: '16px',
          backgroundColor: '#ddd',
          textAlign: 'center',
        }"
      >
        <el-table-column label="" width="50" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column label="分组">
          <template slot-scope="scope">
            <span>{{ groupName(scope.row.groupid) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="组长" align="center" width="70">
          <template slot-scope="scope">
            <span :class="{ cblue: scope.row.isleader === 1 }">{{
              scope.row.isleader === 1 ? "是" : "否"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" />
        <el-table-column prop="remark" label="备注" />
        <el-table-column label="操作" align="center" width="260">
          <template v-if="scope.row.groupid !== 99" slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              @click="userReset(scope.row)"
            >修改</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="toSet(scope.row)"
            >分配卷</el-button>
            <el-button
              type="danger"
              :disabled="scope.row.groupid === 99"
              size="mini"
              @click="userDel(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 分配账号 -->
    <el-dialog
      :title="diotitle + '账号'"
      :visible.sync="dialogFormVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :close="closeUserDiolog"
    >
      <el-form
        ref="userinfo"
        :model="userData"
        label-width="100px"
        style="padding: 20px 20px 0 0"
        :rules="userDataRules"
      >
        <el-form-item label="账号" prop="name">
          <el-input
            v-model="userData.name"
            :disabled="diotitle === '修改'"
            placeholder="请输入账号"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="userData.password"
            :placeholder="
              diotitle === '修改' ? '不填默认使用之前的密码' : '请输入密码'
            "
          />
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="userData.nickname" placeholder="请输入昵称" />
        </el-form-item>
        <el-form-item label="简介" prop="description">
          <el-input
            v-model="userData.description"
            type="textarea"
            placeholder="请输入简介"
            autosize
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="userData.remark"
            type="textarea"
            placeholder="请输入备注"
            autosize
          />
        </el-form-item>
        <el-form-item label="群组">
          <el-select
            v-model="userData.groupid"
            style="width: 100%"
            placeholder="请选择账号所属群组"
          >
            <el-option
              v-for="item in groupList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否是组长">
          <el-radio v-model="userData.isleader" label="1">是</el-radio>
          <el-radio v-model="userData.isleader" label="0">否</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUserDiolog">取 消</el-button>
        <el-button
          type="primary"
          @click="submitInfo('userinfo')"
        >提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { CreateUser, GetUserList, UserDataChange, UserDataDelete } from '@/api/user'
import md5 from 'js-md5'
export default {
  data() {
    return {
      dialogFormVisible: false, // 分配账号弹框
      userData: { // 注册账号标单
        groupid: 0, // 群组
        name: '', // 账号
        password: '', // 密码
        nickname: '', // 昵称
        description: '', // 简介
        remark: '', // 备注
        isleader: '0' // 是否是组长
      },
      userDataRules: {
        name: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入简介', trigger: 'blur' }]
      },
      groupList: [
        { value: 0, label: '阅览' },
        { value: 1, label: '长阿含经翻译' },
        { value: 2, label: '杂阿含经翻译' },
        { value: 3, label: '增一阿含經翻译' },
        { value: 4, label: '中阿含經翻译' },
        { value: 51, label: '审核组' }
      ],
      userDataList: [],
      diotitle: '注册'
    }
  },
  created() {
    this.getUserList()
  },
  methods: {
    toSet(row) {
      const { id } = row.userid
      this.$router.push('/control/' + id)
    },
    groupName(v) {
      if (v === 99) {
        return '管理员'
      }
      for (let i = 0; i < this.groupList.length; i++) {
        const item = this.groupList[i]
        if (item.value === v) {
          return item.label
        }
      }
    },
    userDel(row) {
      this.$confirm('确认删除用户！', '提示', { type: 'warning' }).then(() => {
        const data = {
          name: row.name,
          userid: row.userid.id
        }
        UserDataDelete(data).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功！')
            this.getUserList()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },
    userReset(row) {
      // 修改用户
      this.userDataRules.password[0].required = false
      const { groupid, name, nickname, description, remark, isleader } = row
      this.userData.groupid = groupid
      this.userData.name = name
      this.userData.nickname = nickname
      this.userData.description = description
      this.userData.remark = remark
      this.userData.isleader = String(isleader)
      this.diotitle = '修改'
      this.dialogFormVisible = true
    },
    getUserList() {
      GetUserList().then(res => {
        if (res.code === 200 && res.data) {
          this.userDataList = res.data || []
        }
      })
    },
    registration() {
      // 注册账号弹框
      this.diotitle = '注册'
      this.userDataRules.password[0].required = true
      this.dialogFormVisible = true
    },
    closeUserDiolog() {
      this.userData = { // 注册账号标单
        groupid: 0, // 群组
        name: '', // 账号
        password: '', // 密码
        nickname: '', // 昵称
        description: '', // 简介
        remark: '', // 备注
        isleader: '0'
      }
      this.dialogFormVisible = false
    },
    submitInfo(formName) {
      // 提交分配账号信息
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.userData))
          if (data.password !== '') {
            data.password = md5(data.password)
          }
          if (this.diotitle === '注册') {
            // 注册账号
            CreateUser(data).then(res => {
              if (res.code === 200) {
                this.$message.success('注册成功！')
                this.dialogFormVisible = false
                this.getUserList()
                this.closeUserDiolog()
              } else {
                this.$message.error(res.message || res.msg)
              }
            }).catch(err => {
              window.console.log(err)
            })
          } else if (this.diotitle === '修改') {
            // 修改用户
            UserDataChange(data).then(res => {
              if (res.code === 200) {
                this.$message.success('用户信息修改成功！')
                this.dialogFormVisible = false
                this.getUserList()
                this.closeUserDiolog()
              } else {
                this.$message.error(res.message || '修改失败！')
              }
            }).catch(err => {
              window.console.log(err)
            })
          }
        } else {
          this.$message.warning('请完整输入注册账号信息！')
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
</style>
